import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "../../../../../Components/CustomInput";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import ProgramDrawer from "./ProgramDrawer";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Divider } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "500px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "none",
  },
  dialog_title: {
    marginLeft: "1.5rem",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const ProgramModal = (props) => {
  const {
    isOpen,
    organisationId,
    setAction,
    action,
    dropDownValue,
    setDropDownValue,
    setInputValue,
    inputValue,
    currentSelection,
    onCreateProgramClose,
    handleClose,
    includeMatchingFrameworkValue,
    setIncludeMatchingFrameworkValue,
    programType,
    setProgramType,
  } = props;
  const classes = useStyles();
  const [data, setData] = useState(undefined);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [masterTemplateData, setMasterTemplateData] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentSelection) {
      setInputValue(currentSelection?.name);
      setDropDownValue(currentSelection?.master_template_id);
    }
  }, [currentSelection]);

  const handleDropDownValue = (event) => {
    const { value } = event?.target;
    setDropDownValue(value);
  };

  const handleInputValue = (value) => {
    setInputValue(value);
  };
  useEffect(() => {
    fetchMasterTemplate();
  }, [isOpen]);

  const fetchMasterTemplate = () => {
    DataService.getData({}, "fetchMasterTemplateList")
      .then((response) => {
        if (response["master_templates"]?.length) {
          setMasterTemplateData(response["master_templates"]);
        }
      })
      .catch((err) => {});
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let canSubmit = true;
    var formData = new FormData();

    if (dropDownValue && organisationId && inputValue) {
      formData.append("master_template_id", dropDownValue);

      formData.append("organisation_id", organisationId);
      formData.append("name", inputValue);
      formData.append(
        "include_matching_framework",
        includeMatchingFrameworkValue
      );
      if (includeMatchingFrameworkValue) {
        if (programType < 0) {
          canSubmit = false;
        } else {
          formData.append("program_type_id", programType);
        }
      }
    } else {
      canSubmit = false;
    }
    if (canSubmit) {
      if (currentSelection) {
        formData.append("programme_id", currentSelection?.id);
        DataService.updateData(formData, "", "update_program")
          .then((res) => {
            if (res?.success) {
              onCreateProgramClose();
              // fetchPrograms();
            }
          })
          .catch((error) => {
            setSubmitClickFlag(true);
          });
      } else {
        DataService.createData(formData, "create_program")
          .then((res) => {
            if (res?.success) {
              setAction("addProgram");
              setData(res);
              // fetchPrograms();
            }
          })
          .catch((error) => {
            dispatch(showSnackbar("error", [["" + error.errors]]));
            setSubmitClickFlag(true);
          });
      }
    } else {
      dispatch(showSnackbar("error", ["Please enter all the details"]));
    }
  };

  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth={true}
      open={isOpen}
      onClose={onCreateProgramClose}
      aria-labelledby="base-station-manage"
    >
      <DialogTitle
        id="customized-dialog-title"
        className={classes.dialog_title}
      >
        <Typography variant="h2" style={{ fontWeight: "bold" }}>
          {currentSelection ? "Update" : "Create new"} program
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ margin: "0px auto" }}>
        <div className={classes.formWrapper}>
          <form onSubmit={handleSubmit}>
            <div>
              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
                style={{ marginBottom: 10 }}
              >
                <Grid item xs={3}>
                  <Typography variant="h2" className={classes.title}>
                    Program name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomInput
                    placeholder={"Program Name"}
                    autoFocus
                    error={submitClickFlag && !inputValue ? true : false}
                    helperText={
                      submitClickFlag && !inputValue
                        ? "Please enter the program name.!"
                        : ""
                    }
                    variant="outlined"
                    id="name"
                    name={"name"}
                    parentcall={(value, name) => {
                      handleInputValue(value, name);
                    }}
                    value={inputValue}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
                style={{ marginTop: "1rem" }}
              >
                <Grid item xs={3}>
                  <Typography variant="h2" className={classes.title}>
                    Select template
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <FormControl style={{ width: "100%" }} variant="outlined">
                    <InputLabel style={{ marginTop: "-0.3rem" }}>
                      Choose From master template
                    </InputLabel>
                    <Select
                      error={submitClickFlag && !dropDownValue ? true : false}
                      labelId="master_template_id"
                      id="master_template_id"
                      name="master_template_id"
                      placeholder={"Choose From Master Template"}
                      onChange={handleDropDownValue}
                      value={dropDownValue}
                      label="Master template"
                    >
                      {masterTemplateData?.map((data) => {
                        return (
                          <MenuItem name={data?.id} value={data?.id}>
                            <Typography variant="h2">
                              {data?.template_name}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <FormHelperText
                      style={{ marginLeft: "2px" }}
                      error={submitClickFlag && !dropDownValue ? true : false}
                    >
                      {submitClickFlag && !dropDownValue
                        ? "Please select value.!"
                        : ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-start"}
                style={{ marginTop: "1rem" }}
              >
                <Grid item xs={3}>
                  <Typography variant="h2" className={classes.title}>
                    Include matching framework
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <FormControl style={{ width: "100%" }} variant="outlined">
                    <InputLabel style={{ marginTop: "-0.3rem" }}>
                      Select yes or no
                    </InputLabel>
                    <Select
                      labelId="include_matching_framework_id"
                      id="include_matching_framework_id"
                      name="include_matching_framework_id"
                      placeholder={"Select yes or no"}
                      onChange={(event) => {
                        if (!event.target.value) {
                          setProgramType(-1);
                        }
                        setIncludeMatchingFrameworkValue(event.target.value);
                      }}
                      value={includeMatchingFrameworkValue}
                      label="Include matching framework"
                    >
                      {[
                        { id: 1, label: "Yes", value: true },
                        { id: 2, label: "No", value: false },
                      ]?.map((data) => {
                        return (
                          <MenuItem name={data?.id} value={data?.value}>
                            <Typography variant="h2">{data?.label}</Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {includeMatchingFrameworkValue ? (
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                  style={{ marginTop: "1rem" }}
                >
                  <Grid item xs={3}>
                    <Typography variant="h2" className={classes.title}>
                      Program type
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <InputLabel style={{ marginTop: "-0.3rem" }}>
                        Choose From program type
                      </InputLabel>
                      <Select
                        error={
                          submitClickFlag && programType < 0 ? true : false
                        }
                        labelId="program_type_id"
                        id="program_type_id"
                        name="program_type_id"
                        placeholder={"Choose From program type"}
                        onChange={(event) => {
                          setProgramType(event.target.value);
                        }}
                        value={programType}
                        label="Program type"
                      >
                        {[
                          { label: "Matched", value: 1 },
                          { label: "Matched/Select", value: 2 },
                          { label: "Select", value: 3 },
                        ]?.map((data) => {
                          return (
                            <MenuItem name={data?.label} value={data?.value}>
                              <Typography variant="h2">
                                {data?.label}
                              </Typography>
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <FormHelperText
                        style={{ marginLeft: "2px" }}
                        error={
                          submitClickFlag && programType < 0 ? true : false
                        }
                      >
                        {submitClickFlag && programType < 0
                          ? "Please select value.!"
                          : ""}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
              ) : null}
              <Grid
                container
                spacing={1}
                alignItems={"center"}
                justify={"flex-end"}
                style={{ marginTop: 20 }}
              >
                <Grid item xs={2} style={{ marginRight: "1rem" }}>
                  <Button
                    disableElevation
                    type="button"
                    style={{ textTransform: "none" }}
                    onClick={onCreateProgramClose}
                    variant={"contained"}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    disableElevation
                    type="submit"
                    style={{ textTransform: "none" }}
                    variant={"contained"}
                    color="secondary"
                  >
                    {currentSelection ? "Update" : "Create"}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </form>
        </div>
      </DialogContent>

      {action === "addProgram" && data?.programme_id && (
        <ProgramDrawer
          handleClose={handleClose}
          currentSelection={{ id: data?.programme_id }}
          {...props}
        />
      )}
    </Dialog>
  );
};

export default ProgramModal;
